
(() => {
  const init = (section) => {
    if (section.dataset.rv18Ready === 'true') return;
    section.dataset.rv18Ready = 'true';
    const track = section.querySelector('[data-rv18-track]');
    const slides = Array.from(section.querySelectorAll('.rv18-slide'));
    const prev = section.querySelector('[data-rv18-prev]');
    const next = section.querySelector('[data-rv18-next]');
    const dotsWrap = section.querySelector('[data-rv18-dots]');
    if (!track || slides.length === 0) return;
    let index = 0;
    let timer = null;
    const autoplay = section.dataset.autoplay === 'true';
    const interval = Math.max(3000, Number(section.dataset.interval || 4000));
    const visibleCount = () => window.innerWidth <= 640 ? 1 : (window.innerWidth <= 900 ? 2 : 3);
    const maxIndex = () => Math.max(0, slides.length - visibleCount());
    const step = () => {
      if (slides.length < 2) return 0;
      const a = slides[0].getBoundingClientRect();
      const b = slides[1].getBoundingClientRect();
      return b.left - a.left;
    };
    const buildDots = () => {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      for (let i=0; i<maxIndex()+1; i++) {
        const dot = document.createElement('button');
        dot.type = 'button'; dot.className = 'rv18-dot'; dot.setAttribute('aria-label', `Go to review slide ${i+1}`);
        dot.addEventListener('click', () => { index=i; update(); restart(); });
        dotsWrap.appendChild(dot);
      }
    };
    const update = () => {
      index = Math.min(Math.max(index,0), maxIndex());
      track.style.transform = `translate3d(${-index * step()}px,0,0)`;
      if (dotsWrap) Array.from(dotsWrap.children).forEach((d,i)=>d.classList.toggle('is-active',i===index));
    };
    const goNext = () => { index = index >= maxIndex() ? 0 : index + 1; update(); };
    const goPrev = () => { index = index <= 0 ? maxIndex() : index - 1; update(); };
    const stop = () => { if (timer) clearInterval(timer); timer = null; };
    const start = () => { if (!autoplay || maxIndex()===0) return; stop(); timer = setInterval(goNext, interval); };
    const restart = () => { stop(); start(); };
    next?.addEventListener('click', () => { goNext(); restart(); });
    prev?.addEventListener('click', () => { goPrev(); restart(); });
    section.addEventListener('mouseenter', stop);
    section.addEventListener('mouseleave', start);
    section.addEventListener('focusin', stop);
    section.addEventListener('focusout', start);
    window.addEventListener('resize', () => { buildDots(); index=Math.min(index,maxIndex()); update(); restart(); });
    buildDots(); update(); start();
  };
  const initAll = (root=document) => root.querySelectorAll('[data-rv18-section]').forEach(init);
  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
